import { http } from '@/core/api/';
const apiUrl = 'api/inventorycatalog';

export default {
  add(data) {
    return http.post(apiUrl, data);
  },
  search(params) {
    return http.get(`${apiUrl}/search`, { params });
  },
  get(id) {
    return http.get(`${apiUrl}/${id}`);
  },
  getBook(bookId) {
    return http.get(`${apiUrl}/books/${bookId}`);
  },
  load(payload) {
    return http.post(`${apiUrl}/savebook`, payload);
  },
  editBook(bookId, payload) {
    return http.put(`${apiUrl}/books/${bookId}/edit`, payload);
  },
  getInventoryStatus() {
    return http.get(`${apiUrl}/inventorystatuses`);
  },
  getKeyValue(params) {
    return http.get(`${apiUrl}/keyvalue`, { params });
  },
  getBooksCatalog(catalogId) {
    return http.get(`${apiUrl}/bookscatalog/${catalogId}`);
  },
  markAvailable(id) {
    return http.put(`${apiUrl}/books/${id}/markavailable`);
  },
  getSearchBooks(id, orderId, params) {
    return http.post(`${apiUrl}/books/${id}/${orderId}/details`, params);
  },
  getSearchBooksSummary(id, orderId, params) {
    return http.post(`${apiUrl}/books/${id}/${orderId}/summary`, params);
  },
  assignCenterToBook(ids, centerId) {
    return http.patch(`${apiUrl}/book/center/${centerId}`, ids);
  },
  updateLocation(payload) {
    return http.patch(`${apiUrl}/books/location`, payload);
  },
  applyActionToBook(action, data) {
    return http.post(`${apiUrl}/books/${action}/apply`, data);
  },
  inactiveBook(id) {
    return http.post(`${apiUrl}/book/${id}/inactive`);
  },
  eliminateBook(id) {
    return http.post(`${apiUrl}/book/${id}/eliminate`);
  },
  getTypeFacilities() {
    return http.get(`${apiUrl}/typefacilities`);
  },
  getReasonsByType(reasonTypeId) {
    return http.get(`${apiUrl}/reasons/${reasonTypeId}`);
  },
  getStudents(query) {
    return http.get(`${apiUrl}/searchstudents?query=${query}`);
  },
  loan(data) {
    return http.post(`${apiUrl}/loan/`, data);
  },
  addBookBinnacle(id, data) {
    return http.post(`${apiUrl}/book/${id}/binnacle`, data);
  },
  getBookBinnaclesHistory(bookId) {
    return http.get(`${apiUrl}/book/${bookId}/binnacles`);
  },
  getBookDetails(id) {
    return http.get(`${apiUrl}/book/${id}/detail`);
  },
  getInventoryManagementFilters(id) {
    return http.get(`${apiUrl}/${id}/inventorymanagementfilters`);
  },
  getLoanInformation(id) {
    return http.get(`${apiUrl}/book/${id}/loan`);
  },
  notifyReturn(id, payload) {
    return http.post(`${apiUrl}/books/${id}/notifyreturn`, payload);
  },
  getBookTransferHistory(id) {
    return http.get(`${apiUrl}/${id}/booktransfer/log`);
  },
  getInititalReturnDate(id) {
    return http.get(`${apiUrl}/books/${id}/inititalreturndate`);
  },
  getDocumentsToConfiscate(id) {
    return http.get(`${apiUrl}/books/${id}/documentstoconfiscate`);
  },
  consfiscateBook(data) {
    return http.post(`${apiUrl}/consfiscate`, data);
  },
  nofityLoanExtensionDate(data) {
    return http.post(`${apiUrl}/nofityloanextensiondate/`, data);
  },
  assignToOrder(id, orderId) {
    return http.post(`${apiUrl}/books/${id}/assign/order/${orderId}`);
  },
  getAssignmentHistory(id) {
    return http.get(`${apiUrl}/book/${id}/assignmenthistory`);
  },
  assignStudent(id, data) {
    return http.post(`${apiUrl}/books/${id}/student/assign`, data);
  },
  unassignStudent(id, data) {
    return http.post(`${apiUrl}/books/${id}/student/unassign`, data);
  },
  getBookStudentUnassignReasons(type) {
    return http.get(`${apiUrl}/books/students/unassign/reasons`, {
      params: { type },
    });
  },
  unassignBook(id) {
    return http.post(`${apiUrl}/book/${id}/unassign`);
  },
};
